// extracted by mini-css-extract-plugin
export default {"img-icon":"PropertyFeaturesOption_img-icon__8ddkU"};